/**
 * Platform-detectie helpers — gebruikt voor iOS-specifieke workarounds
 * (Safari blob-URL bug, PDF-opening, share-API, etc.).
 */

/**
 * Detect iOS (iPhone, iPad, iPod).
 * iPadOS 13+ Safari rapporteert zichzelf als macOS in userAgent,
 * dus checken we ook maxTouchPoints om iPad te identificeren.
 */
export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return true;
  // iPadOS 13+: pretendt 'MacIntel' te zijn maar heeft touch
  if (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1) return true;
  return false;
}

/** Detect Safari (alle Apple-Safari smaken, dus ook iPhone/iPad). */
export function isSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /^((?!chrome|android).)*safari/i.test(ua);
}
